import PieChart from "components/charts/PieChart";
import {pieChartData, pieChartOptions} from "variables/charts";
import Card from "components/card";
import {useEffect, useState} from "react";
import useAsyncEffect from "use-async-effect";
import axios from "axios";
import {useUserAuth} from "../../../../context/UserAuthContext";
import {AES, enc} from "crypto-js";
import {useNavigate} from "react-router-dom";

const CategoriesDistributionGraph = () => {

    const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
    const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

    //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/"
    //const CROMPTON_ANALYTICS_URL = "https://iot.crompton.co.in:8443/AAPI/"
    const secretKey = "cromptonssecretkey";


    let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
    const decryptedValueuname = AES.decrypt(Username, secretKey).toString(enc.Utf8);
    const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);
    const navigate = useNavigate();

    let [dataCount, setDataCount] = useState([]);
    let [options, setOptions] = useState([]);
    let [totalData, setTotalData] = useState([]);


    const [pieChartDataValues, setPieChartData] = useState([]);
    const [unit, setUnits] = useState([]);

    const handleLogOut = async () => {
        try {
            await logOut();
            navigate("/");
        } catch (error) {
            ////console.log(error.message);
        }
    }

    function getCategoriesDistribution() {
        if ((accesscontrollevel.toString() === "1") || (accesscontrollevel.toString() === "3") || (accesscontrollevel.toString() === "2") || (accesscontrollevel.toString() === "5")) {
            var chartLabels = [];
            var count = [];
            let total = 0
            var url = CROMPTON_ANALYTICS_URL + "v1/device/categories"

            axios({
                method: "GET", url: url, headers: {
                    Authorization: decryptedValue,
                }

            }).then((res) => {
                //console.log(res.data)
                /*for (var i = 0; i < res.data.length; i++) {
                    chartLabels.push(res.data[i].unit);
                    count.push(res.data[i].count);
                    total = total + res.data[i].count
                }*/
                let newResult = res.data.slice().sort((a, b) => b.count - a.count);
                //console.log(newResult)
                for (let i = 0; i < newResult.length; i++) {
                    chartLabels.push(newResult[i].unit);
                    count.push(newResult[i].count);
                    total = total + newResult[i].count
                }

                setPieChartData(count);
                setUnits(chartLabels)
                setTotalData(total)

                setDataCount(count)
                dataCount = count
                setOptions(chartLabels)
                options = chartLabels

                /*localStorage.setItem("units", JSON.stringify(chartLabels))
                localStorage.setItem("unitCounts", JSON.stringify(count))*/

                /*console.log("Data labels: ", chartLabels)
                console.log("Data values: ", count)*/

            }).catch((error) => {
                //console.log(error)
                if (error.response.data.status === "401" || error.response.data.status === "403") {
                    handleLogOut();
                }
            })

        } else {
            //console.log("Inside stats non admin")
            //setErrorMessage("You do not have permission to view this. Please contact admin.")
        }
    }

    useAsyncEffect(() => {

        getCategoriesDistribution()

    }, [""])
    return (
        <Card extra="rounded-[20px] p-3">
            <div className="flex flex-row justify-between px-3 pt-2">
                <div>
                    <h4 className="text-lg font-bold text-navy-700 dark:text-white">
                        Categories Distribution
                    </h4>
                </div>
            </div>

            <br/>

            <div className="mb-auto flex h-[250px] w-full items-center justify-center">
                <PieChart options={{
                    labels: options,
                    colors: ["#9BBFE0", "#E8A09A", "#FBE29F", "#C6D68F", "#656565", "#FF9500", "#5ACF7A", "#5856D6", "#AF52DE"],
                    chart: {
                        width: "50px",
                    },
                    states: {
                        hover: {
                            filter: {
                                type: "none",
                            },
                        },
                    },
                    legend: {
                        show: false,
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    hover: { mode: null },
                    plotOptions: {
                        donut: {
                            expandOnClick: false,
                            donut: {
                                labels: {
                                    show: false,
                                },
                            },
                        },
                    },
                    fill: {
                        colors: ["#9BBFE0", "#E8A09A", "#FBE29F", "#C6D68F", "#656565", "#FF9500", "#5ACF7A", "#5856D6", "#AF52DE"],
                    },
                    tooltip: {
                        enabled: true,
                        theme: "dark",
                        style: {
                            fontSize: "12px",
                            fontFamily: undefined,
                            backgroundColor: "#000000"
                        },
                    },
                }
                } series={dataCount} />
            </div>
            <div
                className="flex flex-row !justify-between rounded-2xl px-6 py-3 shadow-2xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none">
                <div className="flex flex-col items-center justify-center">
                    <div className="flex items-center justify-center">
                        <div className="h-2 w-2 rounded-full bg-[#9BBFE0]"/>
                        <p className="ml-1 text-xs font-normal text-gray-600">{unit[0]}</p>
                    </div>
                    <p className="mt-px text-xl font-bold text-navy-700  dark:text-white">
                        {(((pieChartDataValues[0] / (totalData)) * 100).toFixed(1)) + "%"}
                    </p>
                </div>

                <div className="h-11 w-px bg-gray-300 dark:bg-white/10"/>

                <div className="flex flex-col items-center justify-center">
                    <div className="flex items-center justify-center">
                        <div className="h-2 w-2 rounded-full  bg-[#E8A09A]"/>
                        <p className="ml-1 text-xs font-normal text-gray-600">{unit[1]}</p>
                    </div>
                    <p className="mt-px text-xl font-bold text-navy-700  dark:text-white">
                        {(((pieChartDataValues[1] / (totalData)) * 100).toFixed(1)) + "%"}
                    </p>
                </div>

                <div className="h-11 w-px bg-gray-300 dark:bg-white/10"/>

                <div className="flex flex-col items-center justify-center">
                    <div className="flex items-center justify-center">
                        <div className="h-2 w-2 rounded-full bg-[#FBE29F]"/>
                        <p className="ml-1 text-xs font-normal text-gray-600">{unit[2]}</p>
                    </div>
                    <p className="mt-px text-xl font-bold text-navy-700 dark:text-white">
                        {(((pieChartDataValues[2] / (totalData)) * 100).toFixed(1)) + "%"}
                    </p>
                </div>

                <div className="h-11 w-px bg-gray-300 dark:bg-white/10"/>

                <div className="flex flex-col items-center justify-center">
                    <div className="flex items-center justify-center">
                        <div className="h-2 w-2 rounded-full bg-[#C6D68F]"/>
                        <p className="ml-1 text-xs font-normal text-gray-600">{unit[3]}</p>
                    </div>
                    <p className="mt-px text-xl font-bold text-navy-700 dark:text-white">
                        {(((pieChartDataValues[3] / (totalData)) * 100).toFixed(1)) + "%"}
                    </p>
                </div>
            </div>
        </Card>
    );
};

export default CategoriesDistributionGraph;
